<template>
  <!-- <div class="webview flex-row align-items-center"> -->
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1>【中】1on1naviサービス使用許諾契約書</h1>
            <p>本契約は、お客様（企業等の法人や官公庁）と株式会社アジャイルHR（以下「当社」という。）との間で、1on1naviサービスの使用権の許諾に関する条件を定めるものです。お客様は、1on1naviサービスの利用の開始の申請をすることで、本契約に同意したものとします。また、本契約書は、2020年4月1日から施行される改正民法第548条の2第1項に定める定型約款となります</p>

            <h2>1.<span>目　的</span></h2>
            <ul class="list-unstyled">
            <li>本契約は、本サービス、本サイト、本アプリ（いずれも第2条に定義する。）の利用に関して当社とお客様との間の権利義務関係を定めることを目的として締結する。</li>
            </ul>
            <h2>2.<span>定　義</span></h2>
            <ul class="list-unstyled">
            <li>本契約において使用する以下の用語は各々以下に定める意味を有するものとする。</li>
            <li>
              <ul class="list-unstyled">
            <li><span class="nth">(1)</span>「本サービス」とは、当社が提供する「1on1navi」という名称のサービス（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含む。）を意味する。本サービスには、本条で定義する「本サイト」及び「本アプリ」が含まれるものとする。</li>
            <li><span class="nth">(2)</span>「本サイト」とは、そのドメインが「1on1navi.com」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含む。）を意味する。</li>
            <li><span class="nth">(3)</span>「本アプリ」とは、本サービスを提供するためのアプリケーション及び関連ソフトウェアを意味する。</li>
            <li><span class="nth">(4)</span>「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含む。）を意味する。</li>
            </ul></li>
            </ul>
            <h2>3.<span>本サービスの利用</span></h2>
            <ul class="list-unstyled">
            <li>お客様は、本契約の有効期間中、本契約に従って、当社の定める方法に従い、本サービスを利用するとともに、利用者（第4条に定義する。）に本サービスを利用させることができるものとする。</li>
            </ul>
            <h2>4.<span>本サービスの利用開始</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>お客様は、当社の定める一定の情報を、当社の定める方法で、当社に提供することにより、当社に対し、本サービスの利用の開始を申請するものとする。</li>
            <li><span class="nth">2.</span>お客様は、本アプリのダウンロードのために、お客様社内のウェブサイト（SSL証明書を取得するものとする）にURLを整備するか、当社が設定したURLを利用するかを選択する。</li>
            <li><span class="nth">3.</span>お客様は、自己の責任で、登録を認めるお客様の役員又は従業員個人を選定し、登録を行わせるものとする。</li>
            <li><span class="nth">4.</span>登録は、必ず本サービスを利用するお客様の役員又は従業員個人が行わなければならず、原則として代理人による登録は認めない。</li>
            <li><span class="nth">5.</span>かかる登録の完了により、本契約に従った本サービスの利用にかかる契約が、登録が完了したお客様の役員又は従業員（以下「利用者」という。）と当社の間に成立するものとする。</li>
            </ul>
            <h2>5.<span>本サービスの水準</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社は、別紙「サービスレベルアグリーメント」に記載するサービスレベルの基準を満たすよう経済的に合理的な努力をし、本サービスを提供するものとする。</li>
            <li><span class="nth">2.</span>サービスレベルアグリーメントは本サービスに関する当社の努力目標を定めたものであり、サービスレベルアグリーメントに記載する基準を満たさない場合であっても当社は損害賠償責任その他いかなる責任も負わないものとする。</li>
            </ul>
            <h2>6.<span>料金及び支払方法</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>お客様は、お客様及び利用者が本サービスを利用することの対価として、別紙「利用料金」に記載する利用料金（初期設定料及び月額使用料）を負担するものとする。</li>
            <li><span class="nth">2.</span>初期設定料は初期設定を行った当該月に、月額使用料は当該月の末日時点の利用者数に応じて、毎月末日締めで計算し、お客様は当月分の利用料金を翌月末日までに当社の指定する銀行口座への振込の方法で当社に支払うものとする。振込手数料その他支払に必要な費用はお客様が負担するものとする。</li>
            <li><span class="nth">3.</span>お客様が利用料金の支払を遅滞した場合、お客様は年14.6％の割合による遅延損害金を当社に支払うものとする。</li>
            <li><span class="nth">4.</span>当社は、本条に基づきお客様から支払いを受けた利用料金については一切返金しないものとする。</li>
            <li><span class="nth">5.</span>新規登録又は登録の抹消等による登録上の利用者数の変動の管理についてはお客様が責任をもって行うものとし、本サービスを利用していない利用者が存在すること等により登録上の利用者数と実際の利用者数が乖離する場合であっても、お客様は登録上の利用者数に応じて利用料金を支払う義務を負うものとする。</li>
            <li><span class="nth">6.</span>「１ｏｎ１プラン・フリーミアムプログラム」適用期間においては、前各項の定めにかかわらず、別紙「１ｏｎ１プラン・フリーミアムプログラム」に定める通りとする。</li>
            </ul>
            <h2>7.<span>アカウント情報の管理</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>お客様及び利用者は、自己の責任において、本サービスにかかるID（利用者のお客様におけるメールアドレス）及びパスワード（IDに対応して利用者が固有に設定する文字列）（これら2つを以下「アカウント情報」という。）を管理及び保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等をしてはならないものとし、利用者をしてかかる行為をさせないものとする。</li>
            <li><span class="nth">2.</span>当社は、アカウント情報によって本サービスの利用があった場合、利用登録を行った本人が利用したものと扱うことができるものとする。</li>
            <li><span class="nth">3.</span>アカウント情報の管理不十分、使用上の過誤、第三者の使用又はアカウント情報が不正確若しくは虚偽であったこと等による損害の責任はお客様及び利用者が負うものとし、当社は一切の責任を負わないものとする。</li>
            <li><span class="nth">4.</span>お客様及び利用者は、 アカウント情報が盗まれ、又は第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとする。</li>
            </ul>
            <h2>8.<span>禁止行為</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>お客様は、利用者が本サービスを利用するにあたり、以下の各号のいずれかに該当する行為をさせないものとする。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>当社、お客様、又は他の利用者その他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為（かかる侵害を直接又は間接に惹起する行為を含む。）</li>
            <li><span class="nth">(2)</span>脅迫行為その他犯罪行為に関連する行為又は公序良俗に反する行為</li>
            <li><span class="nth">(3)</span>法令又は当社、お客様若しくは利用者が所属する業界団体の内部規則に違反する行為</li>
            <li><span class="nth">(4)</span>コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為</li>
            <li><span class="nth">(5)</span>本サービスに関し利用しうる情報を改ざんする行為</li>
            <li><span class="nth">(6)</span>当社が定める一定のデータ容量以上のデータを本サービスを通じて送信する行為、その他本サービスのインフラ設備に対して過度な負担となるストレスをかける行為</li>
            <li><span class="nth">(7)</span>本サイトのサーバーやシステム、セキュリティへの攻撃</li>
            <li><span class="nth">(8)</span>当社が提供するインターフェース以外の方法で本サービスにアクセスを試みる行為</li>
            <li><span class="nth">(9)</span>一人の利用者が複数のアカウント情報を取得する行為</li>
            <li><span class="nth">(10)</span>当社による本サービスの運営を妨害するおそれのある行為</li>
            <li><span class="nth">(11)</span>その他、当社が不適切と判断する行為</li>
            </ul></li>
            <li><span class="nth">2.</span>当社は、本サービスにおける利用者による情報の送信行為が前項各号のいずれかに該当し、又は該当するおそれがあると当社が判断した場合には、お客様及び利用者に事前に通知することなく、当該情報の全部又は一部を削除することができるものとする。当社は、本項に基づき当社が行った措置に基づきお客様及び利用者に生じた損害について一切の責任を負わない。</li>
            </ul>
            <h2>9.<span>本サービスの停止・中断</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社は、以下のいずれかに該当する場合には、お客様及び利用者に事前に通知することなく、本サービスの利用の全部又は一部を停止又は中断することができるものとする。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>本サービスに係るコンピューター・システムの点検又は保守作業を緊急に行う必要のある場合</li>
            <li><span class="nth">(2)</span>コンピューター、通信回線等が事故により停止した場合</li>
            <li><span class="nth">(3)</span>火災、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
            <li><span class="nth">(4)</span>その他、当社が停止又は中断を必要と判断した場合</li>
            </ul></li>
            <li><span class="nth">2.</span>当社は、当社の都合により、本サービスの提供を終了することができるものとする。この場合、当社はお客様及び利用者に事前に通知するものとする。</li>
            <li><span class="nth">3.</span>当社は、本条に基づき当社が行った措置に基づきお客様及び利用者に生じた損害について一切の責任を負わないものとする。</li>
            </ul>
            <h2>10.<span>設備の負担等</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>お客様は、本サービスの提供を受けるに当たり、お客様の費用と責任において以下の環境を整えるものとする。ただし、当社が設定した環境を利用する場合は、この限りではない。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>AppleDevelopmentAccountEnterpriseの契約締結及びAppleDevelopmentアカウントの当社への通知</li>
            <li><span class="nth">(2)</span>お客様の指定したウェブサイト（SSL証明書を取得するものとする）の整備及びアプリ書き出し用証明書の当社への共有</li>
            </ul></li>
            <li><span class="nth">2.</span>前項に規定するほか、本サービスの提供を受けるために必要な、コンピューター、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、お客様及び利用者の費用と責任において行うものとする。</li>
            <li><span class="nth">3.</span>お客様は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとし、利用者をして、かかる対策を講じさせるものとする。</li>
            <li><span class="nth">4.</span>当社は、利用者が送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとする。なお、当社はかかる情報の削除に基づきお客様及び利用者に生じた損害について一切の責任を負わないものとする。</li>
            <li><span class="nth">5.</span>お客様は、本サービスの利用開始に際し又は本サービスの利用中に、ダウンロードその他の方法によりソフトウェア等を利用者のコンピューター等にインストールする場合には、利用者が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとし、利用者がかかるインストールを行う場合にはお客様は利用者に十分な注意させるものとする。当社はかかるインストールにより利用者に損害が発生した場合であっても一切責任を負わないものとする。</li>
            </ul>
            <h2>11.<span>再委託</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社は、本サービスにかかる作業の全部又は一部を、第三者に再委託することができるものとする。</li>
            <li><span class="nth">2.</span>前項の場合、当社は、本契約に基づき当社が負担する義務と同等の義務を当社の責任において、当該再委託先に課すものとする。</li>
            </ul>
            <h2>12.<span>権利帰属</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本サービスに関する所有権及び知的財産権は全て当社又は当社にライセンスを許諾している者に帰属しており、本契約に定める登録に基づく本サービスの利用許諾は、本契約において明示されているものを除き、本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権の譲渡又は使用許諾を意味するものではない。お客様及び利用者は、いかなる理由によっても当社又は当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含むが、これに限定されない。）をしないものとする。</li>
            <li><span class="nth">2.</span>お客様及び利用者は、当社又は当社にライセンスを許諾している者の知的財産権に係る権利表示及び説明を変更してはならないものとする。</li>
            <li><span class="nth">3.</span>本サービス内において、利用者が投稿その他送信を行った文章についての知的財産権は、当該利用者に帰属するものとする。</li>
            </ul>
            <h2>13.<span>情報の確認及び分析</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社は、本契約の違反の有無の確認、その他の必要があると当社が判断する場合は、本サービス内において利用者が投稿その他送信を行った当該文章及びデータ等の内容を確認することができるものとする。</li>
            <li><span class="nth">2.</span>当社は、本サービスに関連して統計データを作成するため、本サービス内において利用者が投稿その他送信を行った文章及びデータ等の内容を分析することができるものとし、お客様はこれを承認する。</li>
            </ul>
            <h2>14.<span>登録取消及び本契約の解除</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社は、利用者が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該利用者について本サービスの利用を一時的に停止し、又は利用者としての登録を取り消すことができるものとし、お客様はかかる登録の取り消し等に対して異議を述べないものとする。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>本契約のいずれかの条項に違反した場合</li>
            <li><span class="nth">(2)</span>登録情報に虚偽の事実があることが判明した場合</li>
            <li><span class="nth">(3)</span>当社、他の利用者その他の第三者に損害を生じさせるおそれのある目的又は方法で、本サービスを利用した又は利用しようとした場合</li>
            <li><span class="nth">(4)</span>手段の如何を問わず、本サービスの運営を妨害した場合</li>
            <li><span class="nth">(5)</span>その他、当社が利用者としての登録の継続を適当でないと判断した場合</li>
            </ul></li>
            <li><span class="nth">2.</span>当社は、お客様が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、本契約を解除することができるものとする。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>本契約のいずれかの条項に違反した場合</li>
            <li><span class="nth">(2)</span>支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合</li>
            <li><span class="nth">(3)</span>自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき</li>
            <li><span class="nth">(4)</span>差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合</li>
            <li><span class="nth">(5)</span>租税公課の滞納処分を受けた場合</li>
            <li><span class="nth">(6)</span>お客様が前項第2号及び第3号に該当する場合</li>
            </ul></li>
            <li><span class="nth">3.</span>前項各号のいずれかの事由に該当した場合、お客様は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければならない。</li>
            <li><span class="nth">4.</span>当社は、本条に基づき当社が行った行為によりお客様及び利用者に生じた損害について一切の責任を負わない。</li>
            <li><span class="nth">5.</span>本条に基づき本契約が解除された場合、お客様は当社の指示に基づき、当社から提供を受けた本サービスに関連するソフトウェア、その他の物につき、返還、廃棄その他の処分を行うものとする。また、本条に基づき利用者の登録が取り消された場合、お客様は、利用者をして、当社の指示に基づき、当社から提供を受けた本サービスに関連するソフトウェア、その他の物につき、返還、廃棄その他の処分を行わせるものとする。</li>
            </ul>
            <h2>15.<span>保証の否認及び免責</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社は、お客様及び利用者の本サービスの利用環境について、事前に合意したものを除き、一切関与せず、また一切の責任を負わない。</li>
            <li><span class="nth">2.</span>当社は、本サービスがお客様の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、お客様及び利用者による本サービスの利用がお客様及び利用者に適用のある法令又は業界団体の内部規則等に適合すること、及び不具合が生じないことについて、何ら保証するものではない。</li>
            <li><span class="nth">3.</span>当社は、本サービスが全ての情報端末に対応していることを保証するものではなく、本サービスの利用に供する情報端末のＯＳのバージョンアップ等に伴い、本サービスの動作に不具合が生じる可能性があることにつき、お客様はあらかじめ了承するものとする。当社は、かかる不具合が生じた場合に当社が行うプログラムの修正等により解消するべく対応するが、当該不具合が解消されることを保証するものではない。</li>
            <li><span class="nth">4.</span>お客様は、Apple、Google等の事業者の契約及び運用方針の変更等に伴い、本サービスの一部又は全部の利用が制限される可能性があることをあらかじめ了承するものとする。</li>
            <li><span class="nth">5.</span>第１項から第4項までの規定は、当社に故意又は重過失が存する場合には適用しない。</li>
            <li><span class="nth">6.</span>本サービスの利用に関し当社が損害賠償責任を負う場合、賠償すべき損害の範囲は、お客様又は利用者に生じた通常の損害に限るものとし、逸失利益を含む特別損害については、その予見可能性の有無を問わず、賠償する責任を負わないものとする。</li>
            <li><span class="nth">7.</span>お客様及び利用者が当社から直接又は間接に、本サービス、本サービスの他の利用者その他の事項に関する何らかの情報を得た場合であっても、当社は利用者に対し本契約において規定されている内容を超えて如何なる保証も行うものではない。</li>
            <li><span class="nth">8.</span>お客様は、本サービスを利用することが、お客様及び利用者に適用のある法令、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、利用者による本サービスの利用が、お客様及び利用者に適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではない。</li>
            <li><span class="nth">9.</span>本サイトから他のウェブサイトへのリンク又は他のウェブサイトから本サイトへのリンクが提供されている場合でも、当社は、本サイト以外のウェブサイト及びそこから得られる情報に関して如何なる理由に基づいても一切の責任を負わないものとする。</li>
            </ul>
            <h2>16.<span>ユーザーの賠償等の責任</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>お客様又は利用者が、本サービスの利用に関連して、当社又は第三者に損害を与えた場合、当社又は第三者に対しその損害（訴訟費用及び弁護士費用を含む）を賠償するものとする。</li>
            <li><span class="nth">2.</span>お客様が、本サービスに関連して、利用者若しくは第三者からクレームを受けた場合、又は、利用者と第三者との間で紛争を生じた場合には、直ちにその内容を当社に通知するとともに、お客様の費用と責任において当該クレーム又は紛争を処理し、当社からの要請に基づき、その経過及び結果を当社に報告するものとする。</li>
            </ul>
            <h2>17.<span>秘密保持</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社及びお客様は、本契約の締結及び履行に伴い知り得た相手方の業務上又は技術上情報であって、相手方が秘密である旨の指定又は明示を行った情報（以下「秘密情報」という）を本契約の履行の目的のためのみに使用するとともに、第三者に開示又は漏えいしてはならないものとする。ただし、事前に相手方からの書面による同意を得た場合はこの限りではない。</li>
            <li><span class="nth">2.</span>前項の定めに係らず、以下の各号の情報は、秘密情報に当たらないものとする。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>開示の時点で既に公知の情報、又は開示後受領者の責によらずして公知となった情報</li>
            <li><span class="nth">(2)</span>秘密情報を開示した当事者（以下「開示者」という。）が開示を行った時点で既に秘密情報を受領した当事者（以下「受領者」という。）が保有していた情報</li>
            <li><span class="nth">(3)</span>受領者が第三者から秘密保持義務を負うことなく正当に入手した情報</li>
            <li><span class="nth">(4)</span>開示者からの開示以降に開発された情報で、開示者からの情報によらないことを証明できる情報</li>
            </ul></li>
            <li><span class="nth">3.</span>国の機関その他から法令に基づき秘密情報の開示を義務付けられた場合、受領者はその開示をすることができる。ただし、受領者はその旨を速やかに開示者に通知するものとする。</li>
            <li><span class="nth">4.</span>当社及びお客様は、本契約終了後又は相手方から請求があった場合、相手方の指示に従い、速やかに秘密情報を返却又は破棄するものとする。</li>
            </ul>
            <h2>18.<span>個人情報の保護</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>対象個人情報とは個人情報保護法第2条に定める個人情報を意味する。</li>
            <li><span class="nth">2.</span>当社及びお客様は、本サービスの運営（以下「本業務」という。）によって知り得た対象個人情報を善良な管理者の注意をもって保管し、書面による承諾を得ることなく本業務の遂行及び統計データの作成以外の目的のために利用し、又は第三者に利用させ若しくは開示・漏洩してはならない。</li>
            <li><span class="nth">3.</span>当社及びお客様は、対象個人情報の漏洩、滅失、毀損の防止その他の対象個人情報の適切な管理のために必要な措置を講じなければならない。</li>
            <li><span class="nth">4.</span>当社及びお客様は、作成した対象個人情報の複製物を廃棄するときは、書類については裁断又は焼却の方法により、電磁的記録についてはデ－タ消去又は媒体の破壊の方法により、これを行うものとする。</li>
            </ul>
            <h2>19.<span>反社会的勢力の排除</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社及びお客様は、自らが以下の各号のいずれにも該当しないことを表明、保証する。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>暴力団、暴力団構成員、準構成員、暴力団関連企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力団、その他の反社会的勢力、若しくはそれらに該当しなくなったときから５年を経過しない者（以下「反社会的勢力」という。）</li>
            <li><span class="nth">(2)</span>東京都暴力団排除条例に規定される規制対象者</li>
            </ul></li>
            <li><span class="nth">2.</span>当社及びお客様は、相手方が前項各号に定める者に該当することが判明した場合、若しくは相手方に以下各号の一に該当する事由が判明した場合、何らの催告を要せず本契約を即時解除することができる。</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>反社会的勢力が経営を支配又は実質的に関与していると認められるとき</li>
            <li><span class="nth">(2)</span>自ら又は第三者の不正の利益を図る若しくは第三者に損害を加える等の目的で反社会的勢力を利用したと認められるとき</li>
            <li><span class="nth">(3)</span>反社会的勢力に資金等を提供し、又は便宜や利益を供するなどの関与をしていると認められるとき</li>
            <li><span class="nth">(4)</span>自ら又は第三者を利用して暴力的な要求行為、法的責任を超えた不当な要求行為、脅迫的な言動を行い、若しくは暴力を用いる等の行為を行ったとき</li>
            <li><span class="nth">(5)</span>その他、前各号に準ずるとき</li>
            </ul></li>
            <li><span class="nth">3.</span>当社及びお客様が前項の規定により本契約を解除した場合、その相手方に損害が生じても一切の損害賠償義務を負担しないものとする。</li>
            </ul>
            <h2>20.<span>有効期間</span></h2>
            <ul class="list-unstyled">
            <li>本契約は、本契約締結日から本サービスの提供が終了した日まで、当社とお客様との間で有効に存続するものとする。</li>
            </ul>
            <h2>21.<span>本契約等の変更</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>当社は、本サービスの内容を自由に変更できるものとする。</li>
            <li><span class="nth">2.</span>当社は、サービスレベルアグリーメントの内容を、本契約に基づく本サービスの内容を変更しない範囲で自由に変更できるものとする。</li>
            </ul>
            <h2>22.<span>完全合意</span></h2>
            <ul class="list-unstyled">
            <li>本サービスに関する問い合わせその他お客様及び利用者から当社に対する連絡又は通知は、本サイト内又は本アプリ内の適宜の場所に設置するお問い合わせフォームからの送信、又は当社が別途定める方法で行うものとする。</li>
            </ul>
            <h2>23.<span>解約</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>お客様は、本サービスの解約を希望する場合は、当社所定の方法により、自ら当社に解約の申し出を行うものとする。</li>
            <li><span class="nth">2.</span>お客様は、本サービスの解約により、解約時に自が有する本サービスの利用に関する一切の権利を失うものとし、当社に対していかなる請求権も行使しないものとする。</li>
            <li><span class="nth">3.</span>第1項に定める解約を申し出た場合は、当社の請求に従って全ての債務の支払を行わなければならないものとする。</li>
            </ul>
            <h2>24.<span>販売店</span></h2>
            <ul class="list-unstyled">
            <li>お客様が、当社指定の販売店等を通じて本サービスの利用の開始を申請する場合、第6条、第22条及び第23条について、当該販売店等とお客様が別段の合意をするときは、それに従うものとする。</li>
            </ul>
            <h2>25.<span>本契約に基づく地位の譲渡等</span></h2>
            <ul class="list-unstyled">
            <li>お客様は、当社の書面による事前の承諾なく、本契約上の地位又は本契約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできないものとする。また、お客様は、利用者をして、本契約上の地位又は本契約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をさせないものとする。</li>
            </ul>
            <h2>26.<span>完全合意</span></h2>
            <ul class="list-unstyled">
            <li>本契約は、本契約に含まれる事項に関する当社とお客様との完全な合意を構成し、口頭又は書面を問わず、本契約に含まれる事項に関する当社とお客様との事前の合意、表明及び了解に優先するものとする。</li>
            </ul>
            <h2>27.<span>分離可能性</span></h2>
            <ul class="list-unstyled">
            <li>本契約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本契約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及びお客様は、当該無効若しくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとする。</li>
            </ul>
            <h2>28.<span>存続規定</span></h2>
            <ul class="list-unstyled">
            <li>第6条（未払がある場合に限る。）、第7条第3項、第8条第2項、第9条第3項、第10条、第12条、第13条、第14条第3項、第4項及び第5項、第15条から第19条まで、並びに第25条から第29条までの規定は本契約の終了後も有効に存続するものとする。ただし、第17条については、本契約終了後3年間に限り存続するものとする。</li>
            </ul>
            <h2>29.<span>準拠法及び管轄裁判所　</span></h2>
            <ul class="list-unstyled">
            <li>本契約の準拠法は日本法とし、本契約に起因し又は関連する一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とする。</li>
            </ul>
            <h2>30.<span>協議解決</span></h2>
            <ul class="list-unstyled">
            <li>当社及びお客様は、本契約に定めのない事項又は本契約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとする。</li>
            </ul>

            <p class="text-right">【2018年12月1日制定】</p>
            <p class="text-right">【2020年1月22日改定】</p>
            <p class="text-right">【2020年3月1日改定】</p>

            <h3 class="text-center">サービスレベルアグリーメント（SLA）</h3>
            <dl>
            <dt>（利用時間）</dt>
            <dd><ul class="list-unstyled">
            <li>本サービスの利用時間は次の通りとします。ただし、メンテナンス時間を除きます。</li>
            <li>　24時間365日（閏年366日）</li>
            </ul></dd>
            <dt>（サポートデスク受付）</dt>
            <dd><ul class="list-adjusted">
            <li><span class="nth">・</span>お客様又は利用者からの問合せのみの受付とさせていただきます。</li>
            <li><span class="nth">・</span>サポートデスク対応時間</li>
            <li><ul class="list-unstyled">
            <li>①電子メール等による受付：24時間365日（閏年366日）</li>
            <li>②①の対応：平日（※）の10:00-17:00</li>
            <li>（※）平日とは土・日曜日・祝日および年末年始（12月29日から1月3日）を除いた日をいうものとします。</li>
            </ul></li>
            </ul></dd>
            <dt>（運用・障害監視）</dt>
            <dd><ul class="list-adjusted">
            <li><span class="nth">・</span>当社は、24時間365日（閏年366日）運用・障害監視を行うものとし、障害のあった場合にはお客様へ通知し、対策を講じるものとします。</li>
            </ul></dd>
            <dt>（メンテナンスのための計画停止等）</dt>
            <dd><ul class="list-adjusted">
            <li><span class="nth">・</span>当社は1か月に1回メンテナンスのため6時間計画停止できるものとします。計画停止は、平日の18:00以降の夜間に行うものとします。</li>
            <li><span class="nth">・</span>クラウド環境の制限により、メンテナンスのため、定期・不定期（数秒～数分間）にアクセスできない場合があります。</li>
            </ul></dd>
            </dl>

            <p class="text-right">以上</p>

            <h3 class="text-center">利用料金</h3>
            <dl>
            <dl>
            <span class="planName">【パフォーマンスプラン】</span>
              <dt class="plan"><span class="planTitle">(初期設定料)</span><span class="planHeading">本サービス導入時</span><span class="planContent">10万円（税別)</span></dt>
              <dl class="planList">
                <dt class="plan"><span class="planTitle">(月額利用料)</span><span class="planHeading">利用者 ~50名</span><span class="planContent planContentPerformanceLeft">5万円（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">51名~100名 </span><span class="planContent">1人あたり1,000円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">101名~200名</span><span class="planContent">1人あたり　900円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">201名~300名</span><span class="planContent">1人あたり　800円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">301名~400名</span><span class="planContent">1人あたり　700円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">401名~500名</span><span class="planContent">1人あたり　600円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">501名~</span><span class="planContent">1人あたり　500円×利用者数（税別)</span></dt>
              </dl>
            </dl>
            <dd><ul class="list-unstyled">
            <li></li>
            <li>例えば、利用者数が250名の場合の月額利用料は、50,000円+1,000円×50名+900円×100名＋800円×50名=23万円になります。</li>
            </ul></dd>
            <dl class="planList">
            <span class="planName">【1on1プラン】</span>
              <dt class="plan"><span class="planTitle">(初期設定料)</span><span class="planHeading">本サービス導入時</span><span class="planContent">5万円（税別)</span></dt>
              <dl>
                <dt class="plan"><span class="planTitle">(月額利用料)</span><span class="planHeading">利用者 ~50名</span><span class="planContent planContentLeft">2.5万円（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">51名~100名 </span><span class="planContent">1人あたり　500円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">101名~200名</span><span class="planContent">1人あたり　450円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">201名~300名</span><span class="planContent">1人あたり　400円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">301名~400名</span><span class="planContent">1人あたり　350円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">401名~500名</span><span class="planContent">1人あたり　300円×利用者数（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">501名~</span><span class="planContent">1人あたり　250円×利用者数（税別)</span></dt>
              </dl>
            </dl>
            <dd><ul class="list-unstyled">
            <li></li>
            <li>例えば、利用者数が250名の場合の月額利用料は、25,000円+500円×50名+450円×100名＋400円×50名=11.5万円になります。</li>
            </ul></dd>
            <dl class="planList">
            <span class="planName">【コンディションプラン（iromoji）】</span>
              <dt class="plan"><span class="planTitle">(初期設定料)</span><span class="planHeading">本サービス導入時</span><span class="planContent">0円（税別)</span></dt>
              <dl>
                <dt class="plan"><span class="planTitle">(月額利用料)</span><span class="planHeading">利用者 ~50名まで</span><span class="planContent planContentLeft">3.8万円（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">　　 　~100名まで</span><span class="planContent planContentLeft">3.8万円（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">　　 　~200名まで</span><span class="planContent planContentLeft">6.5万円（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">　　 　~300名まで</span><span class="planContent planContentLeft">10.4万円（税別)</span></dt>
                <dt class="plan"><span class="planHeading noneTitle">301以上</span><span class="planContent planContentLeft">応相談</span></dt>
              </dl>
            </dl>
            </dl>

            <p class="text-right">以上</p>

            <h3 class="text-center">1on1プラン・フリーミアムプログラム（以下、「本プログラム」という。）</h3>
            <dl class="freemium">
            <dt class="freemiumTitle"><span class="nth">1.</span>本プログラムの適用</dt>
            <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">当社が指定するキャンペーン期間において、本プログラムに申込み、当社の審査を通過して、契約に至った場合に適用される。</span></li>
            <dt class="freemiumTitle"><span class="nth">2.</span>本プログラムの対象</dt>
            <dl class="freemiumList">
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">1on1プランを対象とする。</span></li>
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">パフォーマンスプラン、コンディションプランは対象外とする。</span></li>
            </dl>
            <dt class="freemiumTitle"><span class="nth">3.</span>本プログラムの内容</dt>
            <dl class="freemiumList">
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">初期設定料を無料とする。その代わり、初期設定におけるカスタム設定は行わない。</span></li>
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">「4．本プログラムの無償利用者定員」で規定する定員内の無償利用者の月額利用料を無料とする。</span></li>
            </dl>
            <dt class="freemiumTitle"><span class="nth">3.</span>本プログラムの無償利用者定員</dt>
            <dl class="freemiumList">
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">本プログラムが適応されて契約した時点で、50名を無償利用者の定員とする。</span></li>
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">お客様が他の企業を紹介し、成約に至った場合、成約日以後、1社紹介毎に無償利用者定員を50名増加する。ここでの紹介企業数に上限は設けない、また紹介企業がグループ企業でも対象とする。ただし、紹介企業は10名以上の役員又は従業員で、かつ10名以上を本サービスの利用者として登録することを条件とする。</span></li>
            </dl>
            <dt class="freemiumTitle"><span class="nth">3.</span>本プログラムの解約</dt>
            <dl class="freemiumList">
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">無償利用者が3か月間、1人もアクティブでなかった場合。アクティブでない期間が３か月を過ぎた日が属する月の末日時点で解約を行う。</span></li>
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">無償利用者定員を超えて利用者の登録がなされた場合。当該月の末日時点の登録者数によって定員を超えたか否かの判断を行い、同日に解約を行う。</span></li>
              <li class="freemiumContent"><span class="nth">・</span><span class="freemiumContext">パフォーマンスプラン、コンディションプラン、および1on1プラン（通常版）へ移行する場合。移行日をもって解約を行う。</span></li>
            </dl>
            </dl>

            <p class="text-right">以上</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
/* .webview {
  overflow: auto;
} */
.app{
  display: block;
  overflow: visible;
  height: 100%;
}
.freemium {
  padding-top: 5px;
}
.freemium .freemiumTitle {
  padding-top: 5px;
  padding-bottom: 5px;
}
.freemium .freemiumList {
  display: grid;
  display: -ms-grid;
}
.freemium .freemiumContent {
  padding-left: 10px;
  display : -webkit-inline-flex;
	display : inline-flex;
}
.plan {
  padding-top: 5px;
}
.planName {
  font-weight: bold;
}
.plan > span {
  font-weight: normal;
  padding-right: 50px;
}
.plan .planList {
  padding-bottom: 50px;
  padding-top: 50px;
}
.plan > .planContent {
  float: right;
}
.plan > .planTitle {
  float: left;
}
.plan .noneTitle {
  padding-left: 135px;
}
.plan .planContentPerformanceLeft {
  padding-right: 200px;
}
.plan .planContentLeft {
  padding-right: 190px;
}
.planList {
  padding-top: 5px;
  padding-bottom: 5px;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
  margin: 2rem auto;
}
h2 {
  font-size: 1.25rem;
  font-weight: normal;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
dt > li {

}
span.nth {
  margin-right: 0.5em;
}
/* ul.list-adjusted {
  padding-left: 1.5em;
} */
ul.list-unstyled {
  margin-bottom: 2rem;
}
ul.list-unstyled li {
  margin: 0.8rem auto;
}
</style>

<script>
export default {
  name: 'WebViewLicenseAgreementZh'
}
</script>



// WEBPACK FOOTER //
// src/views/_webview/WebViewLicenseAgreementZh.vue